import { ReactNode, useEffect } from "react";
import { useAppSelector } from "../hooks/useAppSelector";
import { registrationHub } from "../hubs/registrationHub";

/**
 * HubProvider — start SignalR khi user đã login, stop khi logout.
 * Theo dõi access_token trong Redux auth state.
 * Không expose connection — UI đọc state qua Redux.
 */
export const HubProvider = ({ children }: { children: ReactNode }) => {
    const accessToken = useAppSelector(s => s.auth.access_token);

    useEffect(() => {
        if (accessToken) {
            registrationHub.start(accessToken);
        }
        return () => {
            registrationHub.stop();
        };
    }, [accessToken]);

    return <>{children}</>;
};
